import { render, staticRenderFns } from "./OnlineSchedulingCatanduva.vue?vue&type=template&id=19f5ac92&"
import script from "./OnlineSchedulingCatanduva.vue?vue&type=script&lang=js&"
export * from "./OnlineSchedulingCatanduva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports